module.exports = __webpack_public_path__ + "img/mobile_crane.a4a937da.png";